const searchToggle = document.getElementById('usa-search-toggle');
const searchWrapper = document.getElementById('usa-search-wrapper');
const navSecondary = document.querySelector('.usa-nav__secondary-links');
const navLastPrimaryLink = document.querySelector('ul.usa-nav__primary .usa-nav__primary-item:last-child button');

function setSearchToggle() {
  // Check the window width
  if (window.innerWidth >= 1024) {
    // Hide search if button aria-expanded is false
    if (searchToggle.getAttribute('aria-expanded') === 'false') {
      searchWrapper.hidden = true;
    }
  } else {
    // Reset the elements if window size is less than 1024px
    searchWrapper.hidden = false;
    searchToggle.setAttribute('aria-expanded', 'false');
    navSecondary.hidden = false;
  }
}

if (searchToggle) {
  // Toggle search on button click
  // eslint-disable-next-line func-names
  searchToggle.addEventListener('click', function searchClick() {
    const isHidden = searchWrapper.hidden === true || false;

    if (isHidden) {
      searchWrapper.hidden = false;
      navSecondary.hidden = true;
      this.setAttribute('aria-expanded', 'true');
    } else {
      searchWrapper.hidden = true;
      navSecondary.hidden = false;
      this.setAttribute('aria-expanded', 'false');
    }
  });

  // Search toggle setting and display
  setSearchToggle();

  // Adjust search toggle on window resize
  window.addEventListener('resize', setSearchToggle);
}

if (window.innerWidth < 1024) {
  // Remove button styling for last item in the primary nav on mobile.
  navLastPrimaryLink.classList.remove('usa-nav__link--button');
}
